import colors from 'vuetify/lib/util/colors';

/**
 * The app's Vuetify theme and component defaults, shared by the app (plugins/vuetify) and the Help
 * app (src/help). Kept apart from the plugin so Help can use them without the app's icon aliases.
 */
export const lightTheme = {
    dark: false,
    colors: {
        primary: colors.indigo.base,
        secondary: colors.indigo.lighten1,
        tertiary: colors.indigo.lighten3,
        accent: colors.indigo.accent2,
        disabled: colors.grey.lighten1,
        grayBackground: colors.grey.lighten4,
        success: colors.green.darken1,
        warning: colors.orange.darken1,
        info: colors.blue.base,
        pending: colors.deepPurple.lighten2,
        prn: colors.deepPurple.base,
        error: colors.red.darken3,
        inProgress: colors.lightGreen.darken1,
        user: colors.purple.base,
        practitioner: colors.blue.darken2,
        patient: colors.red.base,
        related: colors.teal.base,
        organization: colors.brown.base,
        'bn-color-list-group': colors.grey.lighten4,
        'bn-color-list-item': colors.deepPurple.base,
        'bn-color-list-filter': colors.grey.lighten3,
    },
    variables: {
        // Vuetify's 0.38 leaves disabled fields unreadable against white.
        'disabled-opacity': 0.7,
    },
};

export const vuetifyDefaults = {
    global: {
        density: 'compact',
    },
    VBtn: {
        density: 'default',
    },
    VToolbar: {
        color: 'white',
    },
    VCard: {
        border: true,
        variant: 'flat',
    },
    VTabs: {
        density: 'default',
        color: 'primary',
    },
    VTab: {
        density: 'default',
        height: '100%',
    },
    VChip: {
        density: 'default',
        variant: 'tonal',
        size: 'small',
    },
    VAlert: {
        variant: 'outlined',
    },
};
